import type { ImageURISource } from "react-native";

import type { UnencryptedStorageKey } from "@/hooks/useUnencryptedStorage";
import HomeResourcesCard, {
  HomeContentImage,
} from "@/ui/components/home/HomeResourcesCard";
import { FAIconName, Icon, Text } from "@/ui/core";
import { HStack, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface RecommendedContentCardBlurbProps extends ViewWithTestID {
  blurbText: string;
}

const RecommendedContentCardBlurb = ({
  blurbText,
  testID,
}: RecommendedContentCardBlurbProps) => {
  return (
    <VStack
      backgroundColor={ColorToken.Secondary5}
      gap={6}
      height="100%"
      paddingBottom={18}
      paddingHorizontal={18}
      paddingTop={12}
    >
      <Text
        color={ColorToken.NeutralPrimary}
        testID={joinTestIDs(testID, "blurb-body")}
        variant="body"
      >
        {blurbText}
      </Text>
      <HStack gap={6}>
        <Icon
          color={ColorToken.AccentBlue}
          name={FAIconName.ThumbsUp}
          size="sm"
          testID={joinTestIDs(testID, "blurb")}
        />
        <Text
          color={ColorToken.AccentBlue}
          testID={joinTestIDs(testID, "blurb-caption")}
          variant="captionMedium"
        >
          Recommended for you
        </Text>
      </HStack>
    </VStack>
  );
};

interface RecommendedContentCardProps extends ViewWithTestID {
  analyticsSource: string;
  analyticsTitle: string;
  blurbText: string;
  contentUrl: string;
  imageSource: ImageURISource;
  storageKey: UnencryptedStorageKey;
}

const RecommendedContentCard = ({
  analyticsSource,
  analyticsTitle,
  blurbText,
  contentUrl,
  imageSource,
  storageKey,
  testID,
}: RecommendedContentCardProps) => {
  return (
    <HomeResourcesCard
      analyticsSource={analyticsSource}
      analyticsTitle={analyticsTitle}
      cardHeight={250}
      contentUrl={contentUrl}
      dismissColor={ColorToken.NeutralPrimary}
      storageKey={storageKey}
      testID={testID}
    >
      <VStack>
        <HomeContentImage imageHeight={160} imageSource={imageSource} />
        <RecommendedContentCardBlurb blurbText={blurbText} testID={testID} />
      </VStack>
    </HomeResourcesCard>
  );
};

export default RecommendedContentCard;
